import { IdentifierDTO } from '@zazume/zzm-base';

import { PaginationOptions } from '#/hooks';
import { ActivityChange } from '#/models/activity/ActivityChange';

import { doGet, toPaginatedURL } from '../../helpers';

export const activity = {
  getAll: (relatedModelId: IdentifierDTO) => (pagination: PaginationOptions) =>
    doGet<ActivityChange[]>(toPaginatedURL(`/dashboard/activity/${relatedModelId}`, pagination))
};
